import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { config } from "../../constants/domainConfig";
import SimpleBar from "simplebar";
import { FormattedMessage } from "react-intl";
import { changeLangAction } from "../../actions/WelcomeActions";
import { getContactLinks } from "../../constants/contactLinks";
import { MultiLangDomains } from "../../constants/multiLangSupport";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openNotification: false,
      openLanguage: false,
    };

    this.hideSideBar = this.hideSideBar.bind(this);
  }

  handleClick(name, e) {
    e.preventDefault();
    switch (name) {
      case "notification": {
        this.setState({
          openNotification: !this.state.openNotification,
          openLanguage: false,
        });
        break;
      }
      case "language": {
        this.setState({
          openLanguage: !this.state.openLanguage,
          openNotification: false,
        });
        break;
      }
    }
  }

  componentWillMount() {}

  componentDidMount() {
    var el = new SimpleBar(document.getElementById("sidebar"), {
      autoHide: true,
    });
    el.recalculate();
    el.getScrollElement();
    SimpleBar.removeObserver();
  }

  hideSideBar() {
    document.body.classList.toggle("sidebar-hidden");
    document.body.classList.toggle("sidebar-mobile-show");
  }
  handleChange(event) {
    this.props.changeLang(event);
    this.props.changeLangAction({
      currentLang: event,
    });
  }

  render() {
    let uid = this.props.access.uid;
    const handleClick = this.handleClick;
    const isAdmin = this.props.isAdmin;
    let classNameLang = this.state.openLanguage
      ? "navigate-item navigate-dropdown open"
      : "navigate-item navigate-dropdown";
    classNameLang =
      this.props.currentLang == "ar" ? classNameLang + " ar" : classNameLang;
    let classNameli = "navigate-item";
    classNameli =
      this.props.currentLang == "ar" ? classNameli + " ar" : classNameli;
    const cucaLink = getContactLinks(config.subDomain);
    return (
      <div
        id="sidebar"
        className={
          config.useMobiofitTheme
            ? "sidebar sidebar-mobiofit"
            : "sidebar"
        }
      >
        <a href={`/#/account?uid=${uid}`} onClick={this.hideSideBar}>
          <div className="profile">
            <img
              className="profile__image media"
              data-object-fit="cover"
              src={
                this.props.account.user.profilePic
                  ? this.props.account.user.profilePic
                  : "./img/avatar.png"
              }
              alt="avatar"
            />
            <p className="profile__name">{this.props.account.user.name}</p>
          </div>
        </a>
        <nav className="sidebar-navigate">
          {isAdmin ? (
            <ul
              className="list-unstyled navigate"
              style={config.lang === "ar" ? { paddingRight: "25px" } : {}}
            >
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/home?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home"></i>
                  <span
                    className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                  >
                    <FormattedMessage id="home" defaultMessage="Home" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/domain?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-cogs"></i>
                  <span>Domain</span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/country?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-globe"></i>
                  <span>Country</span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/manage-categories?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-filter"></i>
                  <span>Manage Categories</span>
                </a>
              </li>
            </ul>
          ) : (
            <ul
              className="list-unstyled navigate"
              style={config.lang === "ar" ? { paddingRight: "25px" } : {}}
            >
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/home?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home"></i>
                  <span
                    className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                  >
                    <FormattedMessage id="home" defaultMessage="Home" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/account?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <img
                    className="account-sidebar-icon"
                    src="./img/account3.svg"
                    alt="My Account"
                  />
                  <span
                    className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                  >
                    <FormattedMessage id="myAcc" defaultMessage="My Account" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/favorites?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-star"></i>
                  <span
                    className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                  >
                    <FormattedMessage
                      id="favorites"
                      defaultMessage="Favorites"
                    />
                  </span>
                </a>
              </li>
              {config.subDomain === "rs" ||
                (config.newDomain === "videoflux" && (
                  <div>
                    <li className="navigate-item">
                      <a
                        className="navigate-link"
                        href={`/#/terms-conditions?uid=${uid}`}
                        onClick={this.hideSideBar}
                      >
                        <i className="fa fa-file-text-o"></i>
                        <span
                          className={
                            config.lang == "ar" ? "sidebar-list-ar" : ""
                          }
                        >
                          <FormattedMessage
                            id="tnc"
                            defaultMessage="Terms and Conditions"
                          />
                        </span>
                      </a>
                    </li>
                    <li className="navigate-item">
                      <a
                        className="navigate-link"
                        href={`/#/privacy-policy?uid=${uid}`}
                        onClick={this.hideSideBar}
                      >
                        <i className="fa fa-file-text-o"></i>
                        <span
                          className={
                            config.lang == "ar" ? "sidebar-list-ar" : ""
                          }
                        >
                          <FormattedMessage
                            id="privacyPolicy"
                            defaultMessage="Privacy Policy"
                          />
                        </span>
                      </a>
                    </li>
                  </div>
                ))}
              {config.subDomain === "za.fun-box" && (
                <div className="unsubscribe_field">
                  <h3>
                    <FormattedMessage
                      id="unsubscribe"
                      defaultMessage="unsubscribe"
                    />
                  </h3>
                  <ul>
                    <li>
                      <h6>MTN</h6>
                      <p>
                        To unsubscribe, email{" "}
                        <strong>info@smartcalltech.co.za</strong> or phone
                        0115074779.
                      </p>
                    </li>
                    <li>
                      <h6>Vodacom</h6>
                      <p>
                        To unsubscribe, dial <strong>*135*997#</strong>
                      </p>
                    </li>
                  </ul>
                </div>
              )}
              {config.subDomain === "sa.mobiofitpro" && (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={`https://checksubscription.com/?c=${config.subDomain}`}
                  >
                    <img
                      className="history-sidebar-icon"
                      src="./img/wrong.svg"
                      alt="photo"
                    />
                    <FormattedMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </a>
                </li>
              )}

              {config.subDomain === "ae.mobiofit" && (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href="https://checksubscription.com/?c=ae"
                  >
                    <img
                      className="history-sidebar-icon"
                      src="./img/wrong.svg"
                      alt="unsubscribe"
                    />
                    <FormattedMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </a>
                </li>
              )}

              {config.subDomain === "ae.mobiofit" && (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={`https://my.appspool.net/en/photography/?type=apk&uid=${uid}`}
                    onClick={this.hideSideBar}
                  >
                    <img
                      className="history-sidebar-icon"
                      src="./img/photo.svg"
                      alt="photo"
                    />
                    <span
                      className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                    >
                      <FormattedMessage
                        id="photographsApp"
                        defaultMessage="Photo"
                      />
                    </span>
                  </a>
                </li>
              )}
              {cucaLink && (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={cucaLink}
                    onClick={this.hideSideBar}
                  >
                    <img
                      className="history-sidebar-icon"
                      src="./img/question.svg"
                      alt="question"
                    />
                    <span
                      className={config.lang == "ar" ? "sidebar-list-ar" : ""}
                    >
                      <FormattedMessage id="help" defaultMessage="Contact Us" />
                    </span>
                  </a>
                </li>
              )}
              {config.subDomain == "uk" ? (
                <div>
                  <li className="navigate-item">
                    <a
                      className="navigate-link"
                      href={`/#/home?uid=${uid}`}
                      onClick={(e) =>
                        (window.location = `http://n.lumibrain.com/api/samAuth/?token=${uid}`)
                      }
                    >
                      <img
                        className="history-sidebar-icon"
                        src="./img/brain-icon.png"
                        alt="IQ Games"
                      />
                      <span>
                        <FormattedMessage id="iq" defaultMessage="IQ Games" />
                      </span>
                    </a>
                  </li>

                  <li className="navigate-item">
                    <a
                      className="navigate-link"
                      href={`/#/home?uid=${uid}`}
                      onClick={(e) =>
                        (window.location = `https://explore.mobioastro.com/?uid=${uid}`)
                      }
                    >
                      <img
                        className="history-sidebar-icon"
                        src="./img/saturn.png"
                        alt="Astrology"
                      />
                      <span>
                        <FormattedMessage
                          id="astrology"
                          defaultMessage="Astrology"
                        />
                      </span>
                    </a>
                  </li>
                </div>
              ) : (
                ""
              )}
              {config.subDomain == "iq" || config.subDomain == "iq.mobiofit" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span
                      className={
                        config.lang == "ar"
                          ? "children sidebar-list-ar"
                          : "children"
                      }
                    >
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul
                    className={
                      config.lang == "ar"
                        ? "navigate-dropdown-items sidebar-list-ar"
                        : "navigate-dropdown-items"
                    }
                  >
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("ar")}
                      >
                        <span
                          className={config.lang == "ar" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.ar"
                            defaultMessage="ar"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={config.lang == "en" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="en"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain == "ae.mobioviewtv" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span
                      className={
                        config.lang == "ar"
                          ? "children sidebar-list-ar"
                          : "children"
                      }
                    >
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul
                    className={
                      config.lang == "ar"
                        ? "navigate-dropdown-items sidebar-list-ar"
                        : "navigate-dropdown-items"
                    }
                  >
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("ar")}
                      >
                        <span
                          className={config.lang == "ar" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.ar"
                            defaultMessage="ar"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={config.lang == "en" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="en"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.subDomain === "ch" ||
              config.subDomain === "sa.mobiofitpro" ||
              config.newDomain === "fitshouse" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    {MultiLangDomains[config.country] &&
                      MultiLangDomains[config.country].map((lang) => (
                        <li className={classNameli} key={lang.lang}>
                          <a
                            className="navigate-link"
                            onClick={() => this.handleChange(lang.lang)}
                          >
                            <span
                              className={
                                config.lang == lang.lang ? "activeLang" : ""
                              }
                            >
                              <FormattedMessage
                                id={lang.formatId}
                                defaultMessage={lang.formatDefaultMsg}
                              />
                            </span>
                          </a>
                        </li>
                      ))}
                  </ul>
                  {/* <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          className={config.lang == "de" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          className={config.lang == "fr" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("it")}
                      >
                        <span
                          className={config.lang == "it" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.it"
                            defaultMessage="Italian"
                          />
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          className={config.lang == "en" ? "activeLang" : ""}
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                  </ul> */}
                </li>
              ) : null}
            </ul>
          )}
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLangAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js